<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6 text-right">
                <h1 class="display-3 text-white">
                  سامانه هوشمند گردشگری مارُک
                </h1>
                <p class="lead text-white">
                  لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                  استفاده از طراحان گرافیک است.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>

    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img src="img/theme/landingone.svg" class="img-fluid floating-lg" />
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5 section-organizer">
              <h3>خدمات مارُک ویژه برگزارکنندگان تور</h3>
              <p>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد
                نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
              </p>
              <ul class="list-unstyled mt-4">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="ml-3"
                      icon="ni ni-settings-gear-65"
                    ></badge>
                    <h6 class="mb-0">
                      لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="ml-3"
                      icon="ni ni-html5"
                    ></badge>
                    <h6 class="mb-0">
                      لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="ml-3"
                      icon="ni ni-satisfied"
                    ></badge>
                    <h6 class="mb-0">
                      لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم
                    </h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3">برترین برگزارکنندگان تور</h2>
            <p class="lead text-muted">
              لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
              استفاده از طراحان گرافیک است.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <img
                v-lazy="'img/theme/team-1-800x800.jpg'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">ماهور فریمان </span>
                  <small class="h6 text-muted">متن ساختگی </small>
                </h5>
                <div class="mt-3">
                  <base-button
                    tag="a"
                    href="#"
                    type="success"
                    icon="fa fa-facebook"
                    rounded
                    icon-only
                  ></base-button>
                  <base-button
                    tag="a"
                    href="#"
                    type="success"
                    icon="fa fa-instagram"
                    rounded
                    icon-only
                  ></base-button>
                  <base-button
                    tag="a"
                    href="#"
                    type="success"
                    icon="ni ni-send"
                    rounded
                    icon-only
                  >
                  </base-button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <img
                v-lazy="'img/theme/team-2-800x800.jpg'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">ماهور فریمان </span>
                  <small class="h6 text-muted">متن ساختگی </small>
                </h5>
                <div class="mt-3">
                  <base-button
                    tag="a"
                    href="#"
                    type="success"
                    icon="fa fa-facebook"
                    rounded
                    icon-only
                  ></base-button>
                  <base-button
                    tag="a"
                    href="#"
                    type="success"
                    icon="fa fa-instagram"
                    rounded
                    icon-only
                  ></base-button>
                  <base-button
                    tag="a"
                    href="#"
                    type="success"
                    icon="ni ni-send"
                    rounded
                    icon-only
                  >
                  </base-button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <img
                v-lazy="'img/theme/team-3-800x800.jpg'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">ماهور فریمان </span>
                  <small class="h6 text-muted">متن ساختگی </small>
                </h5>
                <div class="mt-3">
                  <base-button
                    tag="a"
                    href="#"
                    type="success"
                    icon="fa fa-facebook"
                    rounded
                    icon-only
                  ></base-button>
                  <base-button
                    tag="a"
                    href="#"
                    type="success"
                    icon="fa fa-instagram"
                    rounded
                    icon-only
                  ></base-button>
                  <base-button
                    tag="a"
                    href="#"
                    type="success"
                    icon="ni ni-send"
                    rounded
                    icon-only
                  >
                  </base-button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <img
                v-lazy="'img/theme/team-4-800x800.jpg'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                style="width: 200px"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <span class="d-block mb-1">ماهور فریمان </span>
                  <small class="h6 text-muted">متن ساختگی </small>
                </h5>
                <div class="mt-3">
                  <base-button
                    tag="a"
                    href="#"
                    type="success"
                    icon="fa fa-facebook"
                    rounded
                    icon-only
                  ></base-button>
                  <base-button
                    tag="a"
                    href="#"
                    type="success"
                    icon="fa fa-instagram"
                    rounded
                    icon-only
                  ></base-button>
                  <base-button
                    tag="a"
                    href="#"
                    type="success"
                    icon="ni ni-send"
                    rounded
                    icon-only
                  >
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section bg-secondary">
      <div class="container">
        <b-row>
          <b-col
            cols="12"
            xl="4"
            lg="4"
            md="4"
            sm="12"
            xs="12"
            class="box-items-res"
          >
            <a href="/tour">
              <div class="img-place">
                <img src="img/images/imgplace.jpg" class="floating-sm " />
              </div>
              <div class="text-place">
                <h6>رزرو تور</h6>
                <p>
                  لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و
                  با استفاده از طراحان گرافیک است، چاپگرها و
                </p>
              </div>
            </a>
          </b-col>
          <b-col
            cols="12"
            xl="4"
            lg="4"
            md="4"
            sm="12"
            xs="12"
            class="box-items-res"
          >
            <a href="/event">
              <div class="img-place">
                <img src="img/images/imgplace.jpg" class="floating" />
              </div>
              <div class="text-place">
                <h6>رزرو رویداد</h6>
                <p>
                  لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و
                  با استفاده از طراحان گرافیک است، چاپگرها و
                </p>
              </div>
            </a>
          </b-col>
          <b-col
            cols="12"
            xl="4"
            lg="4"
            md="4"
            sm="12"
            xs="12"
            class="box-items-res"
          >
            <a href="/residences">
              <div class="img-place">
                <img src="img/images/imgplace.jpg" class="floating-sm" />
              </div>
              <div class="text-place">
                <h6>رزرو اقامتگاه</h6>
                <p>
                  لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و
                  با استفاده از طراحان گرافیک است، چاپگرها و
                </p>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>
    </section>
    <section class="section bg-secondary">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 text-right">
            <div class="pl-md-5 section-users">
              <h3>رزرو تور اقتصادی</h3>
              <p class="lead">
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است
              </p>
              <p>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است
              </p>
              <p>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <img v-lazy="'img/theme/sample.jpg'" class="card-img-top" />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon
                    points="0,52 583,95 0,95"
                    class="fill-default"
                  ></polygon>
                  <polygon
                    points="0,42 583,95 683,0 0,95"
                    opacity=".2"
                    class="fill-default"
                  ></polygon>
                </svg>
                <h4 class="display-3 font-weight-bold text-white">
                  لورم ایپسوم متن ساختگی
                </h4>
                <p class="lead text-italic text-white">
                  لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                  استفاده از طراحان گرافیک است
                </p>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-help-buy">
      <tabs :fill="false" class="flex-column flex-md-row">
        <tab-pane key="tab1" class="section-reserve">
          <template slot="title">
            رزرو تور و رویداد
          </template>
          <h6>نحوه رزرو</h6>
          <p class="description">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز،
            و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای
            زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و
            متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان
            رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد
            کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه
            راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل
            حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود
            طراحی اساسا مورد استفاده قرار گیرد.
          </p>
          <p class="description">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز،
            و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای
            زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و
            متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان
            رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد
            کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه
            راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل
            حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود
            طراحی اساسا مورد استفاده قرار گیرد.
          </p>
          <b-row>
            <b-col
              cols="12"
              xl="4"
              lg="3"
              md="1"
              class="d-xl-flex d-lg-flex d-md-flex d-sm-none d-xs-none"
            ></b-col>
            <b-col cols="12" xl="4" lg="6" md="10" sm="12" xs="12">
              <b-carousel
                class="slider-reserve"
                id="carousel-1"
                fade
                indicators
                v-model="slide"
                :interval="3000"
                controls
                img-height="300"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
              >
                <b-carousel-slide
                  img-src="../../img/images/helpimg.jpg"
                ></b-carousel-slide>
                <b-carousel-slide
                  img-src="../../img/images/helpimg.jpg"
                ></b-carousel-slide>
                <b-carousel-slide
                  img-src="../../img/images/helpimg.jpg"
                ></b-carousel-slide>
                <b-carousel-slide
                  img-src="../../img/images/helpimg.jpg"
                ></b-carousel-slide>
              </b-carousel>
            </b-col>
            <b-col
              cols="12"
              xl="4"
              lg="3"
              md="1"
              class="d-xl-flex d-lg-flex d-md-flex d-sm-none d-xs-none"
            ></b-col>
          </b-row>
        </tab-pane>

        <tab-pane key="tab2" class="section-reserve">
          <template slot="title">
            انتخاب دقیق
          </template>
          <h6>فیلتر های جستجو</h6>
          <p class="description">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز،
            و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای
            زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و
            متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان
            رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد
            کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه
            راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل
            حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود
            طراحی اساسا مورد استفاده قرار گیرد.
          </p>
          <b-row>
            <b-col
              cols="12"
              xl="4"
              lg="4"
              md="3"
              class="d-xl-flex d-lg-flex d-md-flex d-sm-none d-xs-none"
            ></b-col>
            <b-col cols="12" xl="4" lg="4" md="6" sm="12" xs="12">
              <b-carousel
                class="slider-reserve"
                id="carousel-1"
                fade
                indicators
                v-model="slide"
                :interval="3000"
                controls
                img-height="300"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
              >
                <b-carousel-slide
                  img-src="../../img/images/helpimg.jpg"
                ></b-carousel-slide>
                <b-carousel-slide
                  img-src="../../img/images/helpimg.jpg"
                ></b-carousel-slide>
                <b-carousel-slide
                  img-src="../../img/images/helpimg.jpg"
                ></b-carousel-slide>
                <b-carousel-slide
                  img-src="../../img/images/helpimg.jpg"
                ></b-carousel-slide>
              </b-carousel>
            </b-col>
            <b-col
              cols="12"
              xl="4"
              lg="4"
              md="3"
              class="d-xl-flex d-lg-flex d-md-flex d-sm-none d-xs-none"
            ></b-col>
          </b-row>
        </tab-pane>

        <tab-pane key="tab3" class="section-reserve">
          <template slot="title">
            قوانین استرداد
          </template>
          <h6>قوانین استرداد</h6>
          <p class="description">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز،
            و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای
            زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و
            متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان
            رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد
            کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه
            راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل
            حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود
            طراحی اساسا مورد استفاده قرار گیرد.
          </p>
          <b-row>
            <b-col
              cols="12"
              xl="4"
              lg="4"
              md="3"
              class="d-xl-flex d-lg-flex d-md-flex d-sm-none d-xs-none"
            ></b-col>
            <b-col cols="12" xl="4" lg="4" md="6" sm="12" xs="12">
              <b-carousel
                class="slider-reserve"
                id="carousel-1"
                fade
                indicators
                v-model="slide"
                :interval="3000"
                controls
                img-height="300"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
              >
                <b-carousel-slide
                  img-src="../../img/images/helpimg.jpg"
                ></b-carousel-slide>
                <b-carousel-slide
                  img-src="../../img/images/helpimg.jpg"
                ></b-carousel-slide>
                <b-carousel-slide
                  img-src="../../img/images/helpimg.jpg"
                ></b-carousel-slide>
                <b-carousel-slide
                  img-src="../../img/images/helpimg.jpg"
                ></b-carousel-slide>
              </b-carousel>
            </b-col>
            <b-col
              cols="12"
              xl="4"
              lg="4"
              md="3"
              class="d-xl-flex d-lg-flex d-md-flex d-sm-none d-xs-none"
            ></b-col>
          </b-row>
        </tab-pane>
      </tabs>
    </section>
    <section class="section section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-gradient-violetDark shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-lg-2 ml-lg-auto">
            <div class="position-relative pl-md-5">
              <img src="img/ill/ill-2.svg" class="img-center img-fluid" />
            </div>
          </div>
          <div class="col-lg-6 order-lg-1">
            <div class="d-flex">
              <h4 class="display-3 text-white">
                سوپر اپ مارُک نیاز سفرهای شما
              </h4>
            </div>

            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-tv-2"
                    gradient="violetDark"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pr-4">
                  <h5 class="title text-violetDark">لورم ایپسوم متن ساختگی</h5>
                  <p>
                    لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و
                    با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه
                    و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی
                    تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای
                    کاربردی می باشد.
                  </p>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Build something</h2>
            <p class="lead text-white">
              According to the National Oceanic and Atmospheric Administration,
              Ted, Scambos, NSIDClead scentist, puts the potentially record low
              maximum sea ice extent tihs year down to low ice.
            </p>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-4">
            <icon
              name="ni ni-settings"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <h5 class="text-white mt-3">Building tools</h5>
            <p class="text-white mt-3">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
          </div>
          <div class="col-lg-4">
            <icon
              name="ni ni-ruler-pencil"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <h5 class="text-white mt-3">Grow your market</h5>
            <p class="text-white mt-3">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
          </div>
          <div class="col-lg-4">
            <icon
              name="ni ni-atom"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <h5 class="text-white mt-3">Launch time</h5>
            <p class="text-white mt-3">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 section-contact-us">
      <div class="container">
        <div class="row justify-content-center mt--300">
          <div class="col-lg-8">
            <card gradient="secondary" shadow body-classes="p-lg-5">
              <h4 class="mb-1">Want to work with us?</h4>
              <p class="mt-0">Your project is very important to us.</p>
              <base-input
                class="mt-5"
                alternative
                placeholder="Your name"
                addon-left-icon="ni ni-user-run"
              >
              </base-input>
              <base-input
                alternative
                placeholder="Email address"
                addon-left-icon="ni ni-email-83"
              >
              </base-input>
              <base-input class="mb-4">
                <textarea
                  class="form-control form-control-alternative"
                  name="name"
                  rows="4"
                  cols="80"
                  placeholder="Type a message..."
                ></textarea>
              </base-input>
              <base-button type="default" round block size="lg">
                Send Message
              </base-button>
            </card>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">
              Do you love this awesome
              <span class="text-success">Design System for Bootstrap 4?</span>
            </h2>
            <p class="lead">
              Cause if you do, it can be yours for FREE. Hit the button below to
              navigate to Creative Tim where you can find the Design System in
              HTML. Start a new project or give an old Bootstrap project a new
              look!
            </p>
            <div class="btn-wrapper">
              <a
                href="https://www.creative-tim.com/product/vue-argon-design-system"
                class="btn btn-primary mb-3 mb-sm-0"
                >Download Vue</a
              >
            </div>
            <div class="text-center">
              <h4 class="display-4 mb-5 mt-5">
                Available on these technologies
              </h4>
              <div class="row justify-content-center">
                <div class="col-lg-2 col-4">
                  <a
                    href="https://getbootstrap.com/"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="Bootstrap 4 - Most popular front-end component library"
                  >
                    <img
                      v-lazy="
                        'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/bootstrap.jpg'
                      "
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://www.sketchapp.com/"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="[Coming Soon] Sketch - Digital design toolkit"
                  >
                    <img
                      v-lazy="
                        'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/sketch.jpg'
                      "
                      class="img-fluid opacity-5"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://www.adobe.com/products/photoshop.html"
                    data-toggle="tooltip"
                    data-original-title="[Coming Soon] Adobe Photoshop - Software for digital images manipulation"
                  >
                    <img
                      v-lazy="
                        'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/ps.jpg'
                      "
                      class="img-fluid opacity-5"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://vuejs.org/"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="Vue.js - The progressive javascript framework"
                  >
                    <img
                      v-lazy="
                        'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/vue.jpg'
                      "
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://angularjs.org/"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="[Coming Soon] Angular - One framework. Mobile &amp; desktop"
                  >
                    <img
                      v-lazy="
                        'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/angular.jpg'
                      "
                      class="img-fluid opacity-5"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://reactjs.org/"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="[Coming Soon] React - A JavaScript library for building user interfaces"
                  >
                    <img
                      v-lazy="
                        'https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/react.jpg'
                      "
                      class="img-fluid opacity-5"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
export default {
  name: "residences",
  components: {
    datePicker: VuePersianDatetimePicker,
    Tabs,
    TabPane,
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      selecteTourCategory: null,
      optionTourCategory: [
        { value: null, text: "دسته بندی" },
        { value: "a", text: " ساحلی" },
        { value: "b", text: "اموزشی" },
        { value: "c", text: "کمپ" },
      ],
      selecteTour: null,
      optionTour: [
        { value: null, text: "نوع تور" },
        { value: "a", text: "هر دو" },
        { value: "b", text: "خارجی" },
        { value: "c", text: "داخلی" },
      ],
      selecteOrganizer: null,
      optionOrganizer: [
        { value: null, text: "برگزارکننده" },
        { value: "a", text: "یاترا" },
        { value: "b", text: "یاترا دوم" },
      ],
      selecteEventCategory: null,
      optionEventCategory: [
        { value: null, text: "دسته بندی" },
        { value: "a", text: " ساحلی" },
        { value: "b", text: "اموزشی" },
        { value: "c", text: "کمپ" },
      ],
      selecteEvent: null,
      optionEvent: [
        { value: null, text: "نوع برگزاری رویداد" },
        { value: "a", text: "هر دو" },
        { value: "b", text: "انلاین" },
        { value: "c", text: "حضوری" },
      ],
      selecteEventType: null,
      optionEventType: [
        { value: null, text: " نوع رویداد" },
        { value: "a", text: "تخصصی" },
        { value: "b", text: "عمومی" },
      ],
      selectedorigin: null,
      optionsorigin: [
        { value: null, text: "شهر مبدا" },
        { value: "a", text: "تهران" },
        { value: "b", text: "کرج" },
      ],
      selecteddestination: null,
      optionsdestination: [
        { value: null, text: "شهر مقصد" },
        { value: "a", text: "تهران" },
        { value: "b", text: "کرج" },
      ],
      selectedNumber: null,
      optionsNumber: [
        { value: null, text: "تعداد شب" },
        { value: "a", text: "This is First option" },
        { value: "b", text: "Selected Option" },
        { value: { C: "3PO" }, text: "This is an option with object value" },
        { value: "d", text: "This one is disabled", disabled: true },
      ],
      moment: moment,
      startDate: "",
      endDate: "",
    };
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
<style lang="scss">
.svg-bg {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.slider-reserve {
  .carousel-item {
    height: 300px !important;
    width: 100% !important;

    img {
      height: 100% !important;
      width: 100% !important;
    }
  }

  .carousel-indicators li {
    background-color: #ccc;
  }

  .carousel-indicators .active {
    background-color: #707070;
  }
}
.box-items-res {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;

  .img-place {
    width: 100%;
    height: 300px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      overflow: hidden;
    }
  }

  .text-place {
    width: 100%;
    margin-top: 20px;

    h6 {
      color: #a02d9b;
      font-size: 18px;
    }

    p {
      color: #525f7f;
      font-size: 14px;
    }
  }
}
</style>
